<template>
    <v-dialog
            v-model="isSending"
            persistent
            width="300"
    >
        <v-card
                color="primary"
                dark
        >
            <v-card-text class="text-center">
                <p class="pt-2">{{ ($store.state.sendingLMRRAData)? $vuetify.lang.t('$vuetify.data_transfer.post_busy') : $vuetify.lang.t('$vuetify.cap_settings.loading_cap')}}</p>
                <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "SendingDataOverlayComponent",
        props : {
            isSending : {
                type: Boolean,
                required : true
            }
        }
    }
</script>

<style scoped>

</style>